import { IRBDItem } from "../../../../models/rbd"
import { IDiagramValues } from "../Diagram"
import finder, { SELECTOR } from "../helper/finder"
import { isElement, isSerialTransmission, isParalelTransmission, isRedundantTransmission } from "../helper/validator"
import { getTransmissionEndKey } from "../helper/transmission-end"
import { handleElement, handleSerial, handleParalel } from '.'
import { diagram } from "../constants"

export function handleRedundant(current: IRBDItem, prev: IRBDItem | undefined): IDiagramValues[] {
    let result: IDiagramValues[] = []

    let transmissionElement = finder(current, SELECTOR.TRANSMISSION_ELEMENTS)

    if (Array.isArray(transmissionElement)) {
        transmissionElement.map((i, x) => {
            if (isElement(i)) {
                const element = handleElement(i, prev)
                return result.push(element)
            } else {
                if (isSerialTransmission(i)) {
                    const serial = handleSerial(i, prev)
                    result.push(...serial)
                } else if (isParalelTransmission(i)) {
                    const paralel = handleParalel(i, prev)
                    result.push(...paralel)
                } else if (isRedundantTransmission(i)) {
                    const redundant = handleRedundant(i, prev)
                    result.push(...redundant)
                }
            }
            return undefined
        })
    }

    result = handleRedundantVisibility(current, result)

    const connector = generateRedundantConnector(transmissionElement, current.sequence)
    result.push(connector)
    
    return result;
}

function generateRedundantConnector(elements: IRBDItem[], key: number): IDiagramValues {
    const parent: number[] = [];

    elements.forEach(i => {
        if (isElement(i)) {
            parent.push(i.sequence)
        } else if (isSerialTransmission(i)) {
            parent.push(getTransmissionEndKey(i))
        } else if (isRedundantTransmission(i)) {
            parent.push(i.sequence)
        }
        // TODO: handle when child is parallel
    })
    
    return {
        color: diagram.node.color.connector,
        figure: diagram.node.figure.circle,
        key: key,
        strokeColor: diagram.node.color.border.connector,
        linkColor: diagram.link.color.show,
        text: `1/${elements.length}`,
        width: diagram.node.width.circle,
        containerWidth: diagram.node.width.circle + 2,
        parent: parent
    }
}

/**
 * set the invisible link for spesific relation in redundant transmission
 * 
 * @param current
 * @param result
 * @return
 */
function getFirstDiagramKey(item: IRBDItem): number | undefined {
    if (isElement(item)) {
        return item.sequence
    }

    const elements = finder(item, SELECTOR.TRANSMISSION_ELEMENTS)
    if (!Array.isArray(elements) || elements.length === 0) {
        return undefined
    }

    const first = elements[0]
    if (isElement(first)) {
        return first.sequence
    }

    if (isRedundantTransmission(first) || isSerialTransmission(first)) {
        const nested = finder(first, SELECTOR.TRANSMISSION_ELEMENTS)
        if (Array.isArray(nested) && nested.length > 0 && isElement(nested[0])) {
            return nested[0].sequence
        }
    }

    return undefined
}

export function handleRedundantVisibility(current: IRBDItem, result: IDiagramValues[]): IDiagramValues[] {
    const elements = finder(current, SELECTOR.TRANSMISSION_ELEMENTS)
    const keyOfInvisibleLink: number[] = []

    if (Array.isArray(elements)) {
        elements.forEach((i, x) => {
            if (x > 0) {
                if (isElement(i)) {
                    keyOfInvisibleLink.push(i.sequence)
                } else if (isSerialTransmission(i)) {
                    const firstKey = getFirstDiagramKey(i)
                    if (firstKey !== undefined) {
                        keyOfInvisibleLink.push(firstKey)
                    }
                }
            }
        })
    }

    keyOfInvisibleLink.forEach(k => {
        result.filter(e => e.key === k).forEach(e => {
            e.linkColor = diagram.link.color.hide
        })
    })

    return result
}